export const FieldBorder = (props) => <div className={`field-border ${props.invalid ? 'invalid' : ''}`} />;
